export default function ({ app }) {
  if (app.$auth.user) {
    app.$gtm.push({
      user_id: app.$auth?.user?.id,
      loyalty_level: app.$auth?.user?.ranking?.code,
    })
  }
}
